import BaseLayout from '../../layouts/base/base_layout'
import { Box, Button, Card, Typography } from '@mui/material'
import { ArrowBackRounded } from '@mui/icons-material'
import NotFoundIllustration from "../../assets/background/not_found_illustration.svg";
import { useNavigate } from 'react-router-dom';
import { background, black, greyEnabled, purple } from '../../theme/colors';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <BaseLayout>
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: background,
          px: 2,
        }}
      >
        <Card
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 480,
            borderRadius: 4,
            border: '1px solid #ECECEC',
            p: { xs: 3, sm: 5 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            component="img"
            src={NotFoundIllustration}
            alt=""
            sx={{ width: '100%', maxWidth: 320, height: 'auto', mb: 1 }}
          />

          <Typography variant="h5" fontWeight={700} color={black} mt={2}>
            Page not found
          </Typography>
          <Typography variant="body2" color={greyEnabled} mt={1} maxWidth={360}>
            The page you're looking for doesn't exist, may have been moved, or the link is incorrect.
          </Typography>

          <Box mt={4} width="100%">
            <Button
              fullWidth
              onClick={() => navigate(-1)}
              variant="contained"
              disableElevation
              startIcon={<ArrowBackRounded />}
              sx={{
                bgcolor: purple,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { bgcolor: '#7A2074' },
              }}
            >
              Go Back
            </Button>
          </Box>
        </Card>
      </Box>
    </BaseLayout>
  )
}
